import Box from '@mui/system/Box';
import { useAppSelector } from '../../../app/hooks';
import { selectSelectedTeam, selectTeams } from '../../user/teamsSlice';
import SurveyCard from './SurveyCard';

export default function SurveyList(props: {
  statusFilter: 'all' | 'draft' | 'under_review' | 'approved' | 'launched' | 'closed' | 'deleted';
}) {
  const teamsState = useAppSelector(selectTeams);
  const selectedTeamState = useAppSelector(selectSelectedTeam);

  let surveys = selectedTeamState?.surveys;

  //TODO: Refactor to one enum.
  switch (props.statusFilter) {
    case 'all':
      break;
    case 'draft':
      surveys = surveys?.filter((s) => s.status == 'DRAFT');
      break;
    case 'under_review':
      surveys = surveys?.filter((s) => s.status == 'REVIEW');
      break;
    case 'launched':
      surveys = surveys?.filter((s) => s.status == 'PUBLISHED');
      break;
    //TODO: Approved, closed, and deleted need to be fixed.
    case 'approved':
      surveys = [];
      break;
    case 'closed':
      surveys = [];
      break;
    case 'deleted':
      surveys = surveys?.filter((s) => s.status == 'PUBLISHED');
      break;
    // case 'under_review':
    //   surveys = surveys?.filter((s) => s.status == 'REVIEW');
    //   break;
  }

  // Now sort them.
  if (surveys) surveys = [...surveys!].sort((a, b) => Date.parse(b.created) - Date.parse(a.created));

  return (
    <Box sx={{ backgroundColor: '#f2f2f2', p: 5, overflowY: 'hidden' }}>
      {surveys?.map((s) => (
        <SurveyCard key={s.id} survey={s} />
      ))}
    </Box>
  );
}
